import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/leap-sidebar-shell.css";
import "./styles/operational-page.css";
import "./styles/ui-3-calendar.css";
import "./styles/dashboard-page.css";
import "./styles/track-order-page.css";
import "./styles/leap-antd-data-table.css";
import "./styles/leap-surface-card.css";
import "./styles/calendar-order-drawer.css";
import "./styles/sticky-panel-stack.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
